import styled from '@emotion/styled';

export const Form = styled.form`
  margin-top: 20px;
  background: var(--00A987-auth-pages);
  width: 100%;
  display: flex;
  flex-direction: column;
`;
